// Markdown-lite بدون دیپندنسی
export function escapeHtml(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
export function isSafeUrl(u: string): boolean {
  try { const url = new URL(u); return url.protocol === 'http:' || url.protocol === 'https:'; }
  catch { return false; }
}
export function mdToHtml(input?: string | null): string {
  let text = escapeHtml(String(input ?? ''));

  // تصاویر: ![alt](url)
  text = text.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, (_m, alt, url) => {
    const u = String(url).trim(); if (!isSafeUrl(u)) return `![${alt}](${u})`;
    const a = String(alt ?? '').replace(/"/g, '&quot;');
    return `<img src="${u}" alt="${a}" loading="lazy" referrerpolicy="no-referrer" />`;
  });

  // لینک‌ها: [label](url)
  text = text.replace(/\[([^\]]+)\]\(([^)]+)\)/g, (_m, label, url) => {
    const u = String(url).trim(); if (!isSafeUrl(u)) return `[${label}](${u})`;
    return `<a href="${u}" target="_blank" rel="noopener noreferrer">${label}</a>`;
  });

  // **bold**
  text = text.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  // *italic*
  text = text.replace(/\*([^*]+)\*/g, '<em>$1</em>');

  // لیست ساده: خطوطی که با "- " شروع می‌شود
  const lines = text.split(/\r?\n/);
  const out: string[] = [];
  let inList = false;
  for (const line of lines) {
    if (/^\s*-\s+/.test(line)) {
      if (!inList) { inList = true; out.push('<ul>'); }
      out.push(`<li>${line.replace(/^\s*-\s+/, '')}</li>`);
    } else {
      if (inList) { inList = false; out.push('</ul>'); }
      out.push(line);
    }
  }
  if (inList) out.push('</ul>');

  // <br> برای خطوط عادی
  return out.map(seg =>
    seg.startsWith('<ul>') || seg.startsWith('</ul>') || seg.startsWith('<li>')
      ? seg : seg.replace(/\n/g, '<br/>'),
  ).join('\n');
}

export function renderMd(txt?: string | null) {
  return {__html: mdToHtml(txt)};
}
